export const API_DATABASE_URL = {
	API_RAVITY: process.env.REACT_APP_SERVICE_URL,
	API_REST_RAVITY: process.env.REACT_APP_REST_URL,
	API_RAVITY_INGESTION: process.env.REACT_APP_SERVICE_URL_INGESTION,
	API_STRAPI: 'https://platform-strapi.ravity.io',
};
